import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";

export const crearSoporte = async ({entidad, usuario}) => {


    let doxConse = await obtenerConsecutivo({col: 'consecutivos', id: 'soportes'})
    let conse = doxConse.data

    let deposito = {
        ...entidad,
        estado: 'Nuevo',
        idUsuario: usuario.id,
        nombres: usuario.nombres,
        apellidos: usuario.apellidos,
        celular: usuario.celular,
        correo: usuario.correo,
        cc: usuario.cc,
        consecutivo: conse,
    }

    let dox = await guardarDoc('soportes', deposito)
    if (dox.res) {
        await aumentarConsecutivo({col: 'consecutivos', id: 'soportes', actual: conse})
        return dox
    } else {
        return dox
    }


}